(function (angular, app) {
   "use strict";

   angular.module(app.modules.common.name)
      .factory(app.modules.common.services.http, HTTPFactory);
   
   HTTPFactory.$inject = ["$http"
       , app.modules.common.constants.appsettings
       , app.modules.common.services.functions
       , app.modules.common.services.storage
       , app.modules.common.decorators.resource
   ];
   
   function HTTPFactory($http
       , ggSettings
       , ggFunctions
       , ggStorage
       , ggResource
       ) {
      
      //##//--------------------------------------- 
      
       var transformJSONtoFormData = function (obj) {
           var str = [];
           for (var p in obj)
               str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
           return str.join("&");
       }

       function apiRequest(method, location, data, isTransform) {
           // Bearer Token in Header
           var bearer = ggStorage.get(ggStorage.keys.member.bearertoken);
           var ignoreLoadingBar = false;
           // Ignore loading bar for some requests, and remove it from the data post
           if (data && data.ignoreLoadingBar) {
               ignoreLoadingBar = true;
               delete data.ignoreLoadingBar;
           }
           // Build Request
           var apireq = {
            method: method
            , url: location
            , data: data
            , ignoreLoadingBar: ignoreLoadingBar
           }
           if (isTransform) {
               apireq.headers = {
                   "Content-Type": "application/x-www-form-urlencoded"
                   , "Authorization": "Bearer " + bearer
               }
               apireq.transformRequest = transformJSONtoFormData;
           } else {
               apireq.headers = {
                   "Authorization": "Bearer " + bearer
               }
           }

           return apireq;
       }

      // GET
       var _get = function (location, data, resp) {
           var req = apiRequest("GET", location, data);
           return $http(req);
       }

       // PUT
       var _put = function (location, data, resp) {
           var req = apiRequest("PUT", location, data);
           return $http(req);
       }

       // PATCH
       var _patch = function (location, data, resp) {
           var req = apiRequest("PATCH", location, data);
           return $http(req);
       }

      
      // POST
       var _post = function (location, data, isTransform, resp) {
          var req = apiRequest("POST", location, data, isTransform);
          return $http(req);
       }
      // Classic
       var _classic = function (location, data) {

          // AuthToken in Header
           var token = app.Member.Auth.authToken || "";
           var ignoreLoadingBar = false;
           // Ignore loading bar for some requests, and remove it from the data post
           if (data.ignoreLoadingBar) {
               ignoreLoadingBar = true;
               delete data.ignoreLoadingBar;
           }
          // Build Request
          var apireq = {
             method: "POST"
           , url: location
           , data: data
           , ignoreLoadingBar: ignoreLoadingBar
          }
          apireq.headers = {
               "Content-Type": "application/x-www-form-urlencoded"
               , "Authorization": "Token " + token
          }
          apireq.transformRequest = transformJSONtoFormData;
          return $http(apireq);
       }

      // Delete
       var _delete = function (location, data, isTransform, resp) {
          var req = apiRequest("DELETE", location, data, isTransform);
          return $http(req);
       }

       
      

      // HTTP Request
      // Returns a JSON Object
      function http(method, api, form, resp) {

          

         // Ajax Request
         var apireq = {
          method: method
          , url: api
          , headers: { 
              "Content-Type": "application/x-www-form-urlencoded"
              , "ClubManagementGroupID": ggSettings.clubManagementGroupID 
              , "Authorization" : "Bearer " + bearer 
          }
          , transformRequest: transformJSONtoFormData
          , data: form
         }

         
      }
      
      //##//--------------------------------------- 

      var service = {
         post : _post
         , get: _get
          , put: _put
          , patch: _patch
         , delete: _delete
         , classic : _classic
      };
      
      return service;
   }
   
}(angular, app));
